<template>
  <v-dialog
      v-model="dialog"
      max-width="400px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          outlined
          v-bind="attrs"
          v-on="on"
          block
        >
        <v-icon class="mr-2">{{ mdiFilter }}</v-icon>
          {{ title }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          {{ $t('common.buttons.filterByDate') }}
        </v-card-title>
        <v-card-text class="text-center">
          <vc-date-picker
            v-model="localValue"
            is-expanded
            is-range
          />
        </v-card-text>
        <v-card-actions class="text-right">
          <v-btn text @click="cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="dialog = false">
            {{ $t('common.buttons.filter') }}
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';
import { mdiFilter } from '@mdi/js';

export default {
  name: 'DateRangePicker',
  props: {
    value: {
      type: Object,
      default: () => ({
        start: dayjs().subtract(7, 'day').toDate(),
        end: dayjs().toDate(),
      }),
    },
  },
  data() {
    return {
      mdiFilter,
      dialog: false,
      localValue: {
        start: dayjs().subtract(7, 'day').toDate(),
        end: dayjs().toDate(),
      },
    };
  },
  computed: {
    title() {
      if (!this.localValue) {
        return this.$t('common.buttons.filterByDate');
      }
      return `${this.formatDate(this.localValue.start)} - ${this.formatDate(this.localValue.end)}`;
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
    localValue() {
      this.$emit('input', this.localValue);
    },
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.localValue = {
        start: dayjs().subtract(7, 'day').toDate(),
        end: dayjs().toDate(),
      };
    },
  },
};
</script>
